const NUMBERS_ONLY_ERROR = 'Enter numbers only.';
const LETTERS_ONLY_ERROR = 'Enter letters only.';

const digitsOnlyError = (value: string): string | null =>
  value === '' || /^[0-9]+$/.test(value) ? null : NUMBERS_ONLY_ERROR;

const wholeNumberError = (value: string): string | null =>
  value === '' || /^[0-9]+$/.test(value) ? null : 'Enter a whole number.';

const decimalNumberError = (value: string): string | null =>
  value === '' || /^(?:\d+\.?\d*|\.\d+)$/.test(value) ? null : NUMBERS_ONLY_ERROR;

const percentageError = (value: string): string | null => {
  const numberError = decimalNumberError(value);
  if (numberError !== null || value === '') return numberError;
  return Number(value) <= 100 ? null : 'Enter a percentage from 0 to 100.';
};

const letterGradeError = (value: string): string | null =>
  value === '' || /^[A-Za-z]+$/.test(value) ? null : LETTERS_ONLY_ERROR;

export { decimalNumberError, digitsOnlyError, letterGradeError, percentageError, wholeNumberError };
